import React from 'react';

import InvoicePage from './InvoicePage';

const SalesInvoicePage = ({ organizationId, invoiceId }) => {
    return <InvoicePage path={ `organizations/${organizationId}/sales_invoices/${invoiceId}`} />
};

export default SalesInvoicePage;